import { IHttpClient } from '@micro-frontend-react/employee-experience/lib/IHttpClient';
import { put, getContext, all, takeLatest, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { IsAdminActionType } from './IsAdmin.action-types';
import { receiveIsAdmin } from './IsAdmin.actions';

export function* fetchIsAdmin(): SagaIterator {
  const httpClient: IHttpClient = yield getContext('httpClient');

  try {
    const { data } = yield call([httpClient, httpClient.request], {
      url: `${__API_BASE_URL__}/applications/admin`,
      resource: __API_RESOURCE__,
    });

    yield put(receiveIsAdmin(data));
  } catch {}
}

export function* isAdminSagas(): SagaIterator {
  yield all([takeLatest(IsAdminActionType.REQUEST_IS_ADMIN, fetchIsAdmin)]);
}
